export default "__VITE_ASSET__DQdICIV$__"